"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var RecaptureAction;
(function (RecaptureAction) {
    RecaptureAction.ON_RECAPTURE_CLOSE_CLICK = 'ON_RECAPTURE_CLOSE_CLICK';
    RecaptureAction.ON_RECAPTURE_CLOSE_DIALOG = 'ON_RECAPTURE_CLOSE_DIALOG';
    RecaptureAction.ON_RECAPTURE_SAVE_CLICK = 'ON_RECAPTURE_SAVE_CLICK';
    RecaptureAction.ON_RECAPTURE = 'ON_RECAPTURE';
    RecaptureAction.ON_DO_RECAPTURE = 'ON_DO_RECAPTURE';
    RecaptureAction.onRecaptureCloseClicked = typesafe_actions_1.createAction(RecaptureAction.ON_RECAPTURE_CLOSE_CLICK, function (resolve) { return function () { return resolve(); }; });
    RecaptureAction.closeDialog = typesafe_actions_1.createAction(RecaptureAction.ON_RECAPTURE_CLOSE_DIALOG, function (resolve) { return function () { return resolve(); }; });
    RecaptureAction.recapture = typesafe_actions_1.createAction(RecaptureAction.ON_RECAPTURE, function (resolve) { return function () { return resolve(); }; });
    RecaptureAction.doRecapture = typesafe_actions_1.createAction(RecaptureAction.ON_DO_RECAPTURE, function (resolve) { return function () { return resolve(); }; });
    RecaptureAction.onRecaptureSaveClicked = typesafe_actions_1.createAction(RecaptureAction.ON_RECAPTURE_SAVE_CLICK, function (resolve) { return function () { return resolve(); }; });
})(RecaptureAction || (RecaptureAction = {}));
exports.default = RecaptureAction;
